export const OVERLAY_IDS = {
  AUTO_PROMOTION_POPUP: "auto-promotion-popup",
  ADD_PHONE_NUMBER: "add-phone-number-drawer",
  ADD_EMAIL: "add-email-drawer",
  SURPRISE_ME_POPUP: "surprise-me-popup",
  FREE_BALLS_AUTO_DISPLAY_POPUP: "free-balls-auto-display-popup",
  REFER_AND_EARN_POPUP: "refer-and-earn-popup",
  PERSONAL_HOUR_DRAWER: "personal-hour-drawer",
  COUNTDOWN_BOOST_POPUP: "countdown-boost-popup",
} as const;

export type OverlayId = (typeof OVERLAY_IDS)[keyof typeof OVERLAY_IDS];
